import {useCallback, useEffect, useState} from "react";
import {App} from "antd";
import {AsyncProcessStatusEnum} from "../types/api/assets";
import {useLazyHazardParametersBulkUpdateTaskStatusQuery} from "../redux/api/hazardTypes";

interface AsyncProcessConfig {
  pollingInterval?: number;
  onSuccess?: () => void;
  onError?: (error?: any) => void;
  messages?: {
    loading?: string;
    success?: string;
    error?: string;
  };
  defaultMessages?: boolean; // Se true, mostra i messaggi di default
}

export function useAsyncProcessHazardParameters(config: AsyncProcessConfig) {
  const { message } = App.useApp();
  const [processUuid, setProcessUuid] = useState<string>("");
  
  const defaultPollingInterval = 5000;
  const pollingInterval = config?.pollingInterval ?? defaultPollingInterval;
  const shouldShowDefaultMessages = config?.defaultMessages ?? true;

  const [getAsyncTaskStatus, {data: newProcessData, error: pollingError, isError: isPollingError}] = useLazyHazardParametersBulkUpdateTaskStatusQuery()

  useEffect(() => {
    if (!processUuid) return;

    getAsyncTaskStatus(processUuid);

    const intervalId = setInterval(() => {
      getAsyncTaskStatus(processUuid);
    }, pollingInterval);

    return () => {
      clearInterval(intervalId)
      //message.destroy(processUuid)
    };
  }, [processUuid, pollingInterval, getAsyncTaskStatus, message]);


  const showMessage = useCallback((type: 'loading' | 'success' | 'error', content: string) => {
    if (shouldShowDefaultMessages || config.messages?.[type]) {
      return message.open({
        key: processUuid,
        type,
        content: config.messages?.[type] ?? content,
        duration: 3
      });
    }
  }, [config.messages, message, processUuid, shouldShowDefaultMessages]);

  const start = async (uuid: string) => {

    showMessage('loading', "Processo in corso...")
      ?.then(() => {
        setProcessUuid(uuid);
      })
  };

  const stop = useCallback(() => {
    //message.destroy(processUuid)
    setProcessUuid("");
  }, []);

  useEffect(() => {
    if (!processUuid || !newProcessData) return;

    if (newProcessData.status === AsyncProcessStatusEnum.Completed) {
      stop();
      showMessage('success', "Processo completato con successo!");
      config.onSuccess?.();
    } else if (newProcessData.status === AsyncProcessStatusEnum.Failed || isPollingError) {
      stop();
      showMessage('error', "Errore durante il processo!");
      config.onError?.(pollingError);
    }
  }, [config, isPollingError, newProcessData, processUuid, pollingError, showMessage, stop]);

  return {
    start,
    stop,
    isProcessing: !!processUuid,
    data: newProcessData,
    error: pollingError
  };
}